"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isTradeOption(object) {
    return checkTradeOption(object).fulfilled;
}
exports.isTradeOption = isTradeOption;
function checkTradeOption(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("locale"), __1.hasArray("trades", __1.isString())).withOptions(options).explain();
}
exports.checkTradeOption = checkTradeOption;
//# sourceMappingURL=TradeOption.js.map